import React from 'react'
import { Rect } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const CheckboxUnselectedIcon = createIcon({
    viewBox: '0 0 20 20',
    path: (
        <>
            <Rect x='1' y='1' rx='2' stroke='currentColor' strokeWidth='2' />
        </>
    ),
})

CheckboxUnselectedIcon.displayName = 'CheckboxUnselectedIcon'
